import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Hinjewadicabservice() {



  const cardData = {



keyword: "Hinjewadi Cab Service",

headingDescription: "Garud Cab Service provides comfortable and reliable Hinjewadi Cab Service for IT professionals, corporate travelers, families, tourists, students, and groups requiring convenient local and outstation transportation. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for office travel, corporate meetings, airport transfers, railway station pickups, local transportation, one-way journeys, round trips, sightseeing, and customized outstation trips. With experienced drivers, clean and well-maintained vehicles, comfortable seating, spacious luggage areas, flexible pickup locations across Hinjewadi, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes business and leisure travel convenient. Customers can also arrange private cabs from Hinjewadi to hill stations, pilgrimage destinations, coastal getaways, major cities, and other outstation locations according to their preferred schedule.",

topPlaces: [
  {
    title: "Lavasa",
    description: "Lavasa is a planned hill destination surrounded by mountains, lakes, valleys, and scenic roads, making it suitable for a peaceful weekend drive from Hinjewadi. Families, couples, and corporate groups can enjoy a comfortable private cab journey with flexible sightseeing options. Garud Cab Service provides suitable vehicles for one-way and round-trip travel."
  },
  {
    title: "Bhimashankar",
    description: "Bhimashankar is a renowned pilgrimage destination in the Sahyadri region, known for its Jyotirlinga Temple, forests, and scenic mountain surroundings. Devotees and families from Hinjewadi can travel comfortably by private chauffeur-driven cab. Customers can arrange one-way, round-trip, or customized pilgrimage trips with convenient pickup and return schedules."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a popular hill station known for viewpoints, waterfalls, lakes, strawberry farms, valleys, and pleasant mountain scenery. It is ideal for families and groups planning a longer holiday from Hinjewadi. Garud Cab Service offers Sedan, SUV, Ertiga, Innova, and Innova Crysta options with flexible multi-day sightseeing arrangements."
  },
  {
    title: "Panchgani",
    description: "Panchgani is a scenic hill station surrounded by green valleys, viewpoints, mountains, and historic attractions. Travelers from Hinjewadi can combine Panchgani with Mahabaleshwar for an extended weekend itinerary. Customers can book a comfortable private cab with flexible pickup locations and customized sightseeing stops."
  },
  {
    title: "Shirdi",
    description: "Shirdi is a major pilgrimage destination visited by devotees throughout the year for Sai Baba darshan. Families and senior citizens traveling from Hinjewadi can benefit from direct door-to-door cab transportation. Garud Cab Service provides comfortable vehicles with sufficient luggage space and flexible one-way, round-trip, and overnight travel options."
  },
  {
    title: "Nashik",
    description: "Nashik is an important religious, cultural, and commercial destination known for temples, riverfront areas, heritage attractions, vineyards, and nearby sightseeing locations. Corporate travelers and families from Hinjewadi can book a private cab for business or leisure travel. Customers can customize their route with multiple stops around Nashik."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is a prominent cultural and religious city known for Mahalaxmi Temple, historic sites, traditional cuisine, and regional attractions. It is suitable for pilgrimage, family visits, business travel, and sightseeing from Hinjewadi. Garud Cab Service provides comfortable long-distance cabs with professional chauffeurs and flexible return arrangements."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a popular coastal getaway known for beaches, forts, resorts, and peaceful seaside surroundings. Families and corporate groups from Hinjewadi can plan a weekend trip with private door-to-door transportation. Customers can choose a suitable vehicle and include nearby beaches and attractions in a customized travel itinerary."
  },
  {
    title: "Goa",
    description: "Goa is a popular long-distance destination known for beaches, churches, forts, markets, coastal attractions, and vibrant holiday experiences. Travelers from Hinjewadi can choose a private cab for convenient travel with luggage and flexible stops along the route. Garud Cab Service offers spacious vehicles for one-way, round-trip, and multi-day Goa journeys."
  },
  {
    title: "Aurangabad",
    description: "Aurangabad, officially known as Chhatrapati Sambhajinagar, is a major heritage destination with historic monuments, caves, temples, and cultural attractions. Professionals, families, and tourists from Hinjewadi can travel comfortably in a private cab. Customers can customize their journey for sightseeing, business travel, or an extended heritage tour."
  }
],




"services": [
{
"name": "Hinjewadi Cab Service",
"description": "Book Hinjewadi Cab Service for convenient local, airport, corporate, and outstation transportation across Hinjewadi and nearby Pune areas. Sedan, Ertiga, SUV, and Innova Crysta vehicles can be arranged for daily travel, business trips, family journeys, and long-distance routes."
},
{
"name": "Taxi Service in Hinjewadi",
"description": "Choose Taxi Service in Hinjewadi for comfortable private transportation with flexible pickup and drop arrangements. The service is suitable for office travel, airport transfers, local journeys, family trips, and outstation travel from Hinjewadi."
},
{
"name": "Hinjewadi Cab Booking",
"description": "Make Hinjewadi Cab Booking in advance for reliable transportation based on your preferred pickup time, destination, and vehicle category. Customers can choose suitable cars for local travel, airport drops, corporate requirements, sightseeing, and outstation journeys."
},
{
"name": "Cab Service Near Me Hinjewadi",
"description": "Find Cab Service Near Me Hinjewadi for convenient transportation from different parts of Hinjewadi to Pune, airports, railway stations, business locations, and outstation destinations. Private cabs can be arranged according to passenger count and travel requirements."
},
{
"name": "Outstation Cab Service in Hinjewadi",
"description": "Book Outstation Cab Service in Hinjewadi for comfortable long-distance journeys from Hinjewadi to cities and tourist destinations across Maharashtra and nearby states. One-way and round-trip options are available with sedan, SUV, Ertiga, and Innova Crysta vehicles."
},
{
"name": "Hinjewadi to Pune Airport Cab",
"description": "Choose Hinjewadi to Pune Airport Cab for a convenient airport transfer with scheduled pickup from your home, hotel, office, or residential location. Spacious AC vehicles can be arranged for individuals, families, and business travelers carrying airport luggage."
},
{
"name": "Affordable Cab Service in Hinjewadi",
"description": "Affordable Cab Service in Hinjewadi provides practical transportation options for local travel, airport transfers, corporate requirements, and outstation journeys. Vehicle selection can be based on your budget, passenger count, luggage needs, and travel distance."
},
{
"name": "Hinjewadi Taxi Service 24/7",
"description": "Hinjewadi Taxi Service 24/7 is suitable for passengers requiring transportation during early mornings, late evenings, and flexible travel schedules. Cabs can be arranged for airport transfers, emergency travel, office journeys, local rides, and outstation trips."
},
{
"name": "Corporate Cab Service in Hinjewadi",
"description": "Corporate Cab Service in Hinjewadi supports transportation requirements for IT companies, offices, employees, clients, meetings, and business travel. Comfortable vehicles can be arranged for office transfers, airport pickups, corporate events, and scheduled intercity journeys."
},
{
"name": "Innova Crysta Cab in Hinjewadi",
"description": "Book Innova Crysta Cab in Hinjewadi when you need spacious and premium transportation for families, corporate travelers, airport transfers, and outstation journeys. The vehicle offers comfortable seating and generous luggage capacity for longer trips."
},
{
"name": "Sedan Cab in Hinjewadi",
"description": "Choose Sedan Cab in Hinjewadi for comfortable and economical transportation for individuals, couples, small families, airport transfers, office travel, and intercity journeys. Sedan cars are suitable for both local and outstation requirements."
},
{
"name": "SUV Cab Service Hinjewadi",
"description": "SUV Cab Service Hinjewadi offers spacious transportation for families, groups, and travelers carrying additional luggage. SUVs are suitable for airport transfers, sightseeing, corporate travel, weekend trips, and longer outstation routes from Hinjewadi."
},
{
"name": "Ertiga Cab Service Hinjewadi",
"description": "Ertiga Cab Service Hinjewadi is a practical choice for families and small groups seeking comfortable multi-passenger transportation. The vehicle can be arranged for airport transfers, local travel, corporate trips, sightseeing, and outstation journeys."
},
{
"name": "Hinjewadi to Mumbai Cab",
"description": "Book Hinjewadi to Mumbai Cab for convenient private transportation between Hinjewadi and Mumbai. Sedan, Ertiga, SUV, and Innova Crysta options can be selected for business travel, airport transfers, family journeys, and one-way or round-trip requirements."
},
{
"name": "Hinjewadi Phase 1 Cab Service",
"description": "Hinjewadi Phase 1 Cab Service provides convenient pickup and drop transportation for employees, residents, visitors, and business travelers. Cabs can be arranged from Phase 1 for Pune Airport, railway stations, local destinations, corporate offices, and outstation routes."
},
{
"name": "Hinjewadi Phase 2 Cab Service",
"description": "Choose Hinjewadi Phase 2 Cab Service for reliable private transportation from offices, residential areas, and commercial locations in Phase 2. The service supports airport transfers, corporate travel, local journeys, family trips, and outstation destinations."
},
{
"name": "Hinjewadi Phase 3 Cab Service",
"description": "Hinjewadi Phase 3 Cab Service offers convenient transportation for employees, residents, companies, and visitors traveling from Phase 3. Vehicles can be arranged for airport drops, business meetings, railway station transfers, local travel, and outstation journeys."
},
{
"name": "Office Cab Service in Hinjewadi",
"description": "Office Cab Service in Hinjewadi is designed for convenient employee and business transportation between workplaces, residential areas, airports, railway stations, and meeting locations. Comfortable vehicles can be scheduled for regular office travel and corporate requirements."
},
{
"name": "IT Park Cab Service Hinjewadi",
"description": "IT Park Cab Service Hinjewadi provides transportation for employees, visitors, clients, and corporate teams traveling to and from technology offices and business locations. Sedan, Ertiga, SUV, and Innova Crysta options can support airport, local, and intercity travel."
}
],
"tableData": [
["Hinjewadi Cab Service", "Taxi Service in Hinjewadi"],
["Hinjewadi Cab Booking", "Cab Service Near Me Hinjewadi"],
["Outstation Cab Service in Hinjewadi", "Hinjewadi to Pune Airport Cab"],
["Affordable Cab Service in Hinjewadi", "Hinjewadi Taxi Service 24/7"],
["Corporate Cab Service in Hinjewadi", "Innova Crysta Cab in Hinjewadi"],
["Sedan Cab in Hinjewadi", "SUV Cab Service Hinjewadi"],
["Ertiga Cab Service Hinjewadi", "Hinjewadi to Mumbai Cab"],
["Hinjewadi Phase 1 Cab Service", "Hinjewadi Phase 2 Cab Service"],
["Hinjewadi Phase 3 Cab Service", "Office Cab Service in Hinjewadi"],
["IT Park Cab Service Hinjewadi", "Hinjewadi to Pune Airport Cab"]
]
,



whychoose: [
  {
    WhyChooseheading: "Hinjewadi Cab Service for Local & Corporate Travel",
    WhyChoosedescription: "Private cab transportation in Hinjewadi is a convenient option for IT professionals, corporate teams, residents, visitors, and families travelling to offices, hotels, residential areas, airports, railway stations, and outstation destinations."
  },
  {
    WhyChooseheading: "Pickup from Your Preferred Hinjewadi Location",
    WhyChoosedescription: "Passengers can arrange pickup from their home, office, hotel, residential society, business park, or another accessible location in Hinjewadi according to their travel requirements."
  },
  {
    WhyChooseheading: "Convenient for IT Professionals & Companies",
    WhyChoosedescription: "Employees and businesses can arrange private cabs for office commutes, client meetings, corporate events, business appointments, and travel between Hinjewadi and other commercial areas."
  },
  {
    WhyChooseheading: "Airport & Railway Station Transfers",
    WhyChoosedescription: "Private cabs can be booked for travel between Hinjewadi and Pune Airport, Pune Railway Station, or other preferred transport points, offering direct transportation for passengers with luggage."
  },
  {
    WhyChooseheading: "Comfortable for Families & Groups",
    WhyChoosedescription: "Families, couples, and groups can choose a suitable vehicle according to passenger count, luggage requirements, and comfort preferences for local as well as longer journeys."
  },
  {
    WhyChooseheading: "Local Travel Across Pune",
    WhyChoosedescription: "A Hinjewadi cab can be used for travel to residential areas, shopping destinations, hotels, hospitals, educational institutions, business locations, and other accessible places across Pune."
  },
  {
    WhyChooseheading: "Outstation Trips from Hinjewadi",
    WhyChoosedescription: "Travellers can arrange one-way or round-trip cabs from Hinjewadi to destinations such as Mumbai, Lonavala, Mahabaleshwar, Nashik, Satara, Goa, and other preferred cities."
  },
  {
    WhyChooseheading: "Easy Booking with Garud Cab Service",
    WhyChoosedescription: "Share your Hinjewadi pickup point, destination, travel date, passenger count, luggage details, preferred vehicle, and local or outstation requirement with Garud Cab Service for booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Hinjewadi Cab Service?",
    answer: "Yes, Garud Cab Service provides private cab services in Hinjewadi for local travel, corporate transportation, airport transfers, railway station travel, family trips, and outstation journeys."
  },
  {
    question: "Can I book a cab from anywhere in Hinjewadi?",
    answer: "Yes, pickup can be arranged from a preferred accessible location in Hinjewadi, including homes, offices, hotels, residential societies, and business parks."
  },
  {
    question: "Is Hinjewadi Cab Service suitable for IT employees?",
    answer: "Yes, private cabs can be arranged for IT professionals and employees travelling between Hinjewadi offices, homes, hotels, business locations, and other destinations."
  },
  {
    question: "Can I book a cab from Hinjewadi to Pune Airport?",
    answer: "Yes, private airport transfer services can be arranged from Hinjewadi to Pune Airport according to your preferred travel date and schedule."
  },
  {
    question: "Can I book a cab from Hinjewadi to Pune Railway Station?",
    answer: "Yes, a private cab can be arranged for direct transportation from Hinjewadi to Pune Railway Station or another preferred railway station location."
  },
  {
    question: "Does the service provide outstation cabs from Hinjewadi?",
    answer: "Yes, one-way and round-trip outstation cabs can be arranged from Hinjewadi to destinations such as Mumbai, Lonavala, Mahabaleshwar, Nashik, Satara, Goa, and other cities."
  },
  {
    question: "Is the Hinjewadi cab service suitable for families?",
    answer: "Yes, families and groups can select a suitable vehicle based on passenger numbers, luggage requirements, and preferred comfort level."
  },
  {
    question: "Can companies book cabs in Hinjewadi?",
    answer: "Yes, companies can arrange private cabs for employee travel, client meetings, corporate events, office visits, business appointments, and other professional transportation requirements."
  },
  {
    question: "Can I book a one-way cab from Hinjewadi?",
    answer: "Yes, one-way cab service can be arranged when you need direct transportation from Hinjewadi to your preferred destination without requiring the same vehicle for the return journey."
  },
  {
    question: "How can I book a Hinjewadi Cab Service?",
    answer: "Share your Hinjewadi pickup location, destination, travel date, passenger details, luggage requirements, preferred vehicle, and local or outstation travel requirement with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Akshay Kulkarni",
    feedback: "I arranged a private cab from Hinjewadi for a business meeting in Pune. The direct pickup from my office and comfortable travel made it easier to manage my work schedule.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Deshmukh",
    feedback: "Our family booked a cab from Hinjewadi for an outstation trip. The vehicle was convenient for travelling together and carrying our luggage throughout the journey.",
    rating: 5
  }
];






  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Hinjewadi Cab Service",
  "image": "https://garudcabs.com/assets/images/hinjewadi-cab-service.webp",
  "description": "Book Hinjewadi Cab Service with Garud Cab for safe, comfortable, and reliable local, airport, corporate, and outstation transportation. Get taxi and cab booking services in Hinjewadi for daily travel, IT park commutes, business meetings, airport transfers, family journeys, and intercity trips. Choose Sedan, Ertiga, SUV, Innova, and Innova Crysta vehicles with convenient pickup and drop facilities and flexible one way or round trip options.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/hinjewadi-cab-service"
  }
};




  return (
    <div>



<Helmet>
  <title>Hinjewadi Cab Service | Taxi & Outstation Cab Booking | +91 9970007784</title>

  <meta
    name="description"
    content="Book Hinjewadi Cab Service with Garud Cab for reliable local, airport, corporate, and outstation travel. Get taxi and cab booking services with Sedan, Ertiga, SUV, Innova, and Innova Crysta options for daily and intercity journeys."
  />

  <meta
    name="keywords"
    content="Hinjewadi Cab Service, Taxi Service in Hinjewadi, Hinjewadi Cab Booking, Cab Service Near Me Hinjewadi, Outstation Cab Service in Hinjewadi, Hinjewadi Taxi Service, Hinjewadi Outstation Cab, Hinjewadi Airport Cab, Hinjewadi Local Cab, Hinjewadi One Way Cab, Hinjewadi Cab Rental"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/107.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Hinjewadicabservice;